import React from "react";
import { Form, Row } from "react-bootstrap";

import { Field } from "../../utils/components/form";
import { InputError } from './InputError';

export const InputField = (props = {}) => {
  const {
    name, className, validate, onChange, placeholder, beschreibung, label, labelClass, inputClass, required, ...attributes
  } = props;

  const requiredStar = required ? "*" : "";
  const disabled = attributes && attributes.disabled;
  return (
    <Form.Group as={Row} controlId={name} className="pb-1">
      <Form.Label className={labelClass ? labelClass : null}>
        {label}{requiredStar}
        <span className="fs-5">{beschreibung}</span>
      </Form.Label>
      <Field
        name={name}
        validate={validate}
        required={required}
      >
        {({ input, meta }) => {
          let showError = meta && meta.error && meta.touched;
          let initError = meta && !!meta.initial && meta.initial === input.value && meta.error && !disabled;
          if (required && !input.value && meta && !meta.touched) initError = !disabled;
          if (disabled) showError = false;
          return (
            <>
              <Form.Group className={(inputClass ? inputClass : "") + (showError || initError ? " is-invalid" : "")}>
                <Form.Control
                  {...input}
                  {...attributes}
                  tabIndex="0"
                  autoComplete="off"
                  placeholder={placeholder ? `${placeholder} eingeben...` : null}
                  size="lg"
                  isInvalid={meta && meta.touched && meta.error}
                  isValid={meta && meta.touched && !meta.error}
                  aria-label={label}
                />
              </Form.Group>
              <InputError meta={meta} showError={showError} />
            </>
          );
        }}
      </Field>
    </Form.Group>
  );
};
